export const CONSIGNMENT_OPTIONS_REQUEST = 'CONSIGNMENT_OPTIONS_REQUEST'
export const CONSIGNMENT_OPTIONS_SUCCESS = 'CONSIGNMENT_OPTIONS_SUCCESS'
export const CONSIGNMENT_OPTIONS_FAIL = 'CONSIGNMENT_OPTIONS_FAIL'
export const CONSIGNMENT_OPTIONS_RESET = 'CONSIGNMENT_OPTIONS_RESET'
